m = require 'mithril'

CommonViews = require './CommonViews'

Breadcrumbs = {
	view: (ctrl, args) ->
		items = args.items
		m 'ul.breadcrumbs', items.map (item) ->
			m 'li.breadcrumbs_item', [
				m 'span', {
					onclick: () -> m.route item.url if item.url?
					'class': if item.url? then 'breadcrumbs_item-link' else 'breadcrumbs_item-name'
				}, [
					CommonViews.icon(item.icon, 'breadcrumbs_icon') if item.icon?
					item.label
				]
			]
}

module.exports = Breadcrumbs